(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vv-size-view"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vv-size-view')) {
    customElements.define('vv-size-view', class extends HTMLElement {
      connectedCallback() {
        this.mode = 'original';
        this.originals = new WeakMap();
        this.onClick = event => {
          const button = event.target.closest('button[data-system]');
          if (!button || !this.contains(button) || button.disabled) return;
          event.preventDefault();
          event.stopPropagation();
          this.mode = button.dataset.system;
          this.refresh();
        };
        this.addEventListener('click', this.onClick);
        this.observer = new MutationObserver(() => this.refresh());
        this.refresh();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.onClick);
      }
      parse(value) {
        const result = {};
        const pattern = /\b(men(?:['’]s)?|women(?:['’]s)?|youth|kids?|boys?|girls?|gs|m|w)\s*(?:size\s*)?(?:us\s*)?[:\-]?\s*(\d+(?:\.\d+)?)(?:\s*[yY])?\b/gi;
        for (const match of value.matchAll(pattern)) {
          const key = /^(women|w$)/i.test(match[1]) ? 'women' : /^(men|m$)/i.test(match[1]) ? 'men' : 'youth';
          if (result[key] && result[key] !== match[2]) return {};
          result[key] = match[2];
        }
        const youth = value.match(/\b(\d+(?:\.\d+)?)\s*Y\b/i);
        if (youth && !result.youth) result.youth = youth[1];
        return result;
      }
      refresh() {
        this.observer?.disconnect();
        const native = this.querySelector('.vv-size-view__native');
        const records = [];
        for (const input of native.querySelectorAll('input[type="radio"][data-option-name]')) {
          if (!/size/i.test(input.dataset.optionName)) continue;
          const node = input.closest('label')?.querySelector('.variant-option__button-label__text');
          if (node) records.push({node, original: input.value});
        }
        for (const select of native.querySelectorAll('select')) {
          const label = select.closest('.variant-option')?.querySelector('label');
          if (!/size/i.test(label?.textContent || '')) continue;
          for (const node of select.options) records.push({node, original: node.value});
        }
        for (const node of native.querySelectorAll('[data-testid="variant-option-single-value"]')) {
          if (!/size/i.test(node.parentElement.textContent)) continue;
          if (!this.originals.has(node)) this.originals.set(node, node.textContent.trim());
          records.push({node, original: this.originals.get(node)});
        }
        const fallback = this.querySelector('.vv-size-view__fallback');
        if (!records.length) {
          const sizeLine = (this.dataset.description || '').match(/\bsize\s*:\s*([^\n]+?)(?=\bcondition\s*:|\bstyle\s*:|$)/i);
          if (sizeLine && Object.keys(this.parse(sizeLine[1])).length) records.push({node:fallback, original:sizeLine[1].trim()});
        }
        const available = new Set();
        for (const record of records) {
          record.sizes = this.parse(record.original);
          Object.keys(record.sizes).forEach(key => available.add(key));
        }
        const controls = this.querySelector('.vv-size-view__controls');
        controls.hidden = !available.size;
        for (const button of controls.querySelectorAll('button')) {
          button.disabled = button.dataset.system !== 'original' && !available.has(button.dataset.system);
          button.setAttribute('aria-pressed', String(button.dataset.system === this.mode));
          button.title = button.disabled ? this.dataset.missing : '';
        }
        for (const record of records) {
          const size = record.sizes[this.mode];
          const label = this.mode === 'original' ? record.original : size ? 'US ' + size + (this.mode === 'youth' ? 'Y' : '') : record.original + ' — ' + this.dataset.missing;
          record.node.textContent = label;
          record.node.title = record.original;
          if (record.node === fallback) fallback.hidden = false;
        }
        this.observer?.observe(this, {childList:true, characterData:true, subtree:true});
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
